function HomePageSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.897193 6.48918C0.356445 7.47396 0.356445 8.66465 0.356445 11.0439V12.6267C0.356445 16.6823 0.356445 18.7111 1.57521 19.9715C2.79293 21.2318 4.75418 21.2318 8.67565 21.2318H12.8352C16.7567 21.2318 18.718 21.2318 19.9357 19.9715C21.1544 18.7111 21.1544 16.6833 21.1544 12.6267V11.045C21.1544 8.66465 21.1544 7.475 20.6137 6.48918C20.075 5.50231 19.0882 4.89085 17.1155 3.66585L15.0357 2.37533C12.9507 1.08066 11.9077 0.433838 10.7554 0.433838C9.60324 0.433838 8.56126 1.08066 6.47522 2.37533L4.39542 3.66585C2.42273 4.89085 1.4369 5.50231 0.897193 6.48918ZM9.97552 17.0722C9.97552 17.2791 10.0577 17.4775 10.204 17.6237C10.3502 17.77 10.5486 17.8522 10.7554 17.8522C10.9623 17.8522 11.1607 17.77 11.3069 17.6237C11.4532 17.4775 11.5354 17.2791 11.5354 17.0722V13.9525C11.5354 13.7457 11.4532 13.5473 11.3069 13.4011C11.1607 13.2548 10.9623 13.1726 10.7554 13.1726C10.5486 13.1726 10.3502 13.2548 10.204 13.4011C10.0577 13.5473 9.97552 13.7457 9.97552 13.9525V17.0722Z"
        fill="white"
      />
    </svg>
  );
}

export default HomePageSvg;
